/* eslint-disable */
import { resolveQuery } from './query'
import parser from 'ua-parser-js'

let ua = navigator.userAgent
let webappReg = /webapp$/i
let passengerReg = /didi\.passenger\/([\d\.]+)|didies/i
let dAndroidReg = /didigsui.*_(.+)_\d+/gi
let dIosReg = /ddudriver.*_(.+)$/gi
let androidReg = /android/i
let iosReg = /iphone|ipad|ipod/i
let wxReg = /MicroMessenger/i
let alipayReg = /AlipayClient/i
let qqReg = /QQ\/([\d.]+)/
let rnReg = /didi\.rn\.webview/i
let query = resolveQuery(window.location.href || '')

let isDAndroid = !!dAndroidReg.exec(ua)
let isDIos = !!dIosReg.exec(ua)
let isDriver = isDAndroid || isDIos || false
let isPassenger = !!passengerReg.exec(ua)
let isNative = isPassenger || isDriver || false

let is = {
  'wx': !!wxReg.test(ua),
  'alipay': !!alipayReg.test(ua),
  'mqq': !!qqReg.test(ua),
  'native': isNative,
  'passenger': isPassenger,
  'driver': isDriver,
  'dAndroid': isDAndroid,
  'dIos': isDIos,
  'webapp': !!webappReg.exec(query.from || ''),
  'android': !!androidReg.exec(ua),
  'ios': !!iosReg.exec(ua),
  'rnWebview': !!rnReg.exec(ua)
}

let appVer = getPassengerVer()
let model = getModel()
let osName = getOsName()

function getPassengerVer () {
  if (isPassenger) {
    const ret = passengerReg.exec(ua)
    if (ret && ret[1]) {
      return ret[1]
    }
    return ''
  }
  return ''
}

function getOsName () {
  if (is.android) {
    return 'android'
  } else if (is.ios) {
    return 'ios'
  }
  return 'other'
}

function getModel () {
  let deviceModel = ''
  try {
    let deviceInfo = parser(ua)
    deviceModel = deviceInfo.device.model
  } catch (e) {
    console.error(e)
  }
  return deviceModel
}

export {
  is,
  appVer,
  model,
  osName
}
